import kebabCase from 'lodash/kebabCase';

export const strToLinkObj = (string: string, prefix: string = '', result: boolean = false) => ({
    path: `${prefix ? `${prefix}/` : ''}${kebabCase(string)}${result ? '/results' : ''}`,
    text: string
});
